import _ from 'underscore';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import { jsdataRawDataPlugin } from '@bingads-webui-campaign/pgrid-js-data-raw-data';
import { inlineErrorPlugin } from '@bingads-webui/projection-grid-inline-error';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { performanceLogPlugin, perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { assistedSelectionPlugin } from '@bingads-webui/projection-grid-assisted-selection';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/keywords-tab');
const appConfig = globalContext.require('component/config/index');
const logger = globalContext.require('module/service/instrumentation/index');

export function getPlugins({
  perfMarker,
  viewport,
}) {
  return _.compact([{
    // For accurate grid init latency, PerfMarkerPlugin should be the first plugin to load.
    plugin: perfMarkerPlugin,
    config: {
      appConfig,
      marker: perfMarker,
    },
  }, {
    plugin: editablePlugin,
    config: { i18n },
  }, {
    plugin: paginationPlugin,
    config: {
      availablePageSizes: [20, 50, 100, 200],
      enableRandomPage: false,
      pageSizeText: i18n.getString('Grid_ShowRows'),
      totalPageCountText: i18n.getString('Grid_PageOf'),
    },
  }, {
    plugin: performanceLogPlugin,
    config: { appConfig, logger },
  }, {
    plugin: assistedSelectionPlugin,
  }, {
    plugin: a11yPlugin,
    config: { i18n },
  }, {
    plugin: jsdataRawDataPlugin,
  }, {
    plugin: uiBlockerPlugin,
    config: { el: viewport },
  }, {
    plugin: inlineErrorPlugin({
      errorIconClasses: ['grid-error'],
    }),
  }]);
}
